<article class="Tile Tile--{{ color() }}" [class.Tile--filled]="type() === ETileType.filled">
	<p
		class="Tile__label FontSize--{{ fontSizeLabel() }}"
		[class.Tile__label--uppercase]="uppercase()"
	>
		<app-icon [icon]="icon()" [iconSize]="iconSize()" />
		{{ name() }}
	</p>
	<p class="Tile__value FontSize--{{ fontSize() }}">
		@if (composedValue()) {
			@for (line of displayLines(); track $index) {
				<span class="Tile__value-line" [class.Tile__value-line--small]="line.small">{{
					line.text
				}}</span>
			}
		} @else {
			{{ value() || '-' }}
		}
	</p>
</article>
